import React, { useState } from 'react';
import { Button, Input, Badge } from '@h2/ui';
import { X } from 'lucide-react';
import { useConfigurationStore } from '../../stores/useConfigurationStore';

interface TagItem {
  key: string;
  value: string;
}

interface PresetTagsFieldProps {
  fieldId: string;
}

export const PresetTagsField: React.FC<PresetTagsFieldProps> = ({ fieldId }) => {
  const { formData, updateField } = useConfigurationStore();
  const [tagKey, setTagKey] = useState('');
  const [tagValue, setTagValue] = useState('');
  
  const tags = (formData[fieldId] as TagItem[]) || [];

  const handleAddTag = () => {
    if (tagKey.trim() && tagValue.trim()) {
      const newTag = { key: tagKey.trim(), value: tagValue.trim() };
      const updatedTags = [...tags, newTag];
      updateField(fieldId, updatedTags);
      setTagKey('');
      setTagValue('');
    }
  };

  const handleRemoveTag = (keyToRemove: string) => {
    const updatedTags = tags.filter(tag => tag.key !== keyToRemove);
    updateField(fieldId, updatedTags);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    }
  };

  return (
    <div className="space-y-3">
      <div className="flex gap-2">
        <Input
          placeholder="키 (예: 언어)"
          value={tagKey}
          onChange={(e) => setTagKey(e.target.value)}
          onKeyDown={handleKeyDown}
          className="flex-1"
        />
        <Input
          placeholder="값 (예: 한국어)"
          value={tagValue}
          onChange={(e) => setTagValue(e.target.value)}
          onKeyDown={handleKeyDown}
          className="flex-1"
        />
        <Button 
          type="button" 
          onClick={handleAddTag} 
          disabled={!tagKey.trim() || !tagValue.trim()}
        >
          추가
        </Button>
      </div>
      
      {tags.length > 0 && (
        <div className="flex gap-2 flex-wrap">
          {tags.map((tag) => (
            <Badge key={tag.key} variant="secondary" className="text-sm">
              {tag.key}: {tag.value}
              <button
                type="button"
                onClick={() => handleRemoveTag(tag.key)}
                className="ml-1 hover:text-destructive"
              >
                <X className="h-3 w-3" />
              </button>
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
};
